import React, { useState } from 'react';
import AnnouncementItem from "../Common/AnnouncementItem";
import AnnoucementImage01 from "../../../../assets/image/image-annoucement-01.webp";
import Button from "../../../form/Button";

const SectionAnnoucements = () => {
  const announcementData = [
    {
      _id: 1,
      title: "Cultural Exchange: Building Global",
      description: "Stay connected with the latest announcements from the V’Peters Family Scholarship. Explore our calendar for upcoming events and see how we’re making a lasting impact!",
      image: AnnoucementImage01,
      date: {
        day: 22,
        month: "January",
      },
      link: "/updates/1"
    },
    {
      _id: 2,
      title: "Cultural Exchange: Building Global",
      description: "Stay connected with the latest announcements from the V’Peters Family Scholarship. Explore our calendar for upcoming events and see how we’re making a lasting impact!",
      image: AnnoucementImage01,
      date: {
        day: 22,
        month: "January",
      },
      link: "/updates/2"
    },
    {
      _id: 3,
      title: "Cultural Exchange: Building Global",
      description: "Stay connected with the latest announcements from the V’Peters Family Scholarship. Explore our calendar for upcoming events and see how we’re making a lasting impact!",
      image: AnnoucementImage01,
      date: {
        day: 22,
        month: "January",
      },
      link: "/updates/3"
    },
    {
      _id: 4,
      title: "Cultural Exchange: Building Global",
      description: "Stay connected with the latest announcements from the V’Peters Family Scholarship. Explore our calendar for upcoming events and see how we’re making a lasting impact!",
      image: AnnoucementImage01,
      date: {
        day: 22,
        month: "January",
      },
      link: "/updates/4"
    },
    {
      _id: 5,
      title: "Cultural Exchange: Building Global",
      description: "Stay connected with the latest announcements from the V’Peters Family Scholarship. Explore our calendar for upcoming events and see how we’re making a lasting impact!",
      image: AnnoucementImage01,
      date: {
        day: 22,
        month: "January",
      },
      link: "/updates/5"
    },
  ];

  const [visibleAnnoucement, setVisibleAnnoucement] = useState(3);
  const loadMoreAnnoucement = () => {
    setVisibleAnnoucement((prev) => prev + 2);
  };

  return (
    <>
      <section className="relative flex w-full py-16 sm:py-24 bg-white">
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
          {announcementData?.length > 0 && (
            <div className="">
              {announcementData?.slice(0, visibleAnnoucement).map((item, index) => (
                <AnnouncementItem key={index} index={index} data={item} />
              ))}
            </div>
          )}
          {visibleAnnoucement < announcementData.length && (
            <div className="flex items-center justify-center mt-16">
              <Button
                buttonLabel={"Load More"}
                buttonClasses={"!h-12 xl:!h-14 !rounded-full !px-6 xl:!px-10 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white min-w-60"}
                buttonLabelClasses={"!text-base xl:!text-xl"}
                buttonFunction={loadMoreAnnoucement}
              />
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default SectionAnnoucements;